import { useEffect, useMemo } from "react";
import { useRawTable } from "../../hooks";

export default function Module_HealthAnalysisManagement_Table({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
}) {
  const moduleDataTemp = useMemo(
    () => ({
      ...moduleData,
      columns: [
        {
          key: "aa",
          rawKey: [],
          field: "aa",
          header: "健康異常四級",
          child: null,
        },
        {
          key: "bb",
          rawKey: [],
          field: "bb",
          header: "健康異常三級",
          child: null,
        },
        {
          key: "cc",
          rawKey: [],
          field: "cc",
          header: "人因工程",
          child: null,
        },
        {
          key: "dd",
          rawKey: [],
          field: "dd",
          header: "過負荷(心理)",
          child: null,
        },
        {
          key: "ee",
          rawKey: [],
          field: "ee",
          header: "母性保護",
          child: null,
        },
        {
          key: "ff",
          rawKey: [],
          field: "ff",
          header: "新進同仁",
          child: null,
        },
        {
          key: "gg",
          rawKey: [],
          field: "gg",
          header: "個人健康問題",
          child: null,
        },
        {
          key: "total_row",
          field: "total_row",
          header: "總數",
          colSpan: 1,
          rowSpan: 1,
        },
      ],
    }),
    [moduleData]
  );
  const { setTbData, renderTable } = useRawTable({
    setting: moduleDataTemp,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!apiData) return;

    let formatData = [
      {
        CaseStatus: "需諮詢人數",
        order: 99,
        aa: 4,
        bb: 15,
        cc: 3,
        dd: 4,
        ee: null,
        ff: null,
        gg: null,
      },
      {
        CaseStatus: "已諮詢",
        order: 99,
        aa: 3,
        bb: 11,
        cc: 2,
        dd: 3,
        ee: null,
        ff: null,
        gg: null,
      },
      {
        CaseStatus: "自行追蹤",
        order: 99,
        aa: null,
        bb: null,
        cc: null,
        dd: null,
        ee: null,
        ff: null,
        gg: null,
      },
      {
        CaseStatus: "已離職",
        order: 99,
        aa: null,
        bb: null,
        cc: null,
        dd: null,
        ee: null,
        ff: null,
        gg: null,
      },
      // {
      //   CaseStatus: "健檢諮詢%",
      //   order: 99,
      //   aa: 75,
      //   bb: 73,
      //   cc: 67,
      //   dd: 75,
      //   ee: null,
      //   ff: null,
      //   gg: null,
      // },
    ];

    formatData = formatData.map((item) => {
      let total =
        (item.aa ?? 0) +
        (item.bb ?? 0) +
        (item.cc ?? 0) +
        (item.dd ?? 0) +
        (item.ee ?? 0) +
        (item.ff ?? 0) +
        (item.gg ?? 0);

      return { ...item, total_row: total };
    });

    const formatPercent = (data, key) => {
      let total = data.reduce((pre, cur) => (pre += cur[key]), 0),
        all = data.find((item) => item.CaseStatus === "需諮詢人數")?.[key] ?? 0;

      return total && all
        ? `${(((total - all) * 100) / all).toFixed(0)}%`
        : "0%";
    };

    let calPercent = {
      CaseStatus: "健檢諮詢%",
      aa: formatPercent(formatData, "aa"),
      bb: formatPercent(formatData, "bb"),
      cc: formatPercent(formatData, "cc"),
      dd: formatPercent(formatData, "dd"),
      ee: formatPercent(formatData, "ee"),
      ff: formatPercent(formatData, "ff"),
      gg: formatPercent(formatData, "gg"),
      total_row: formatPercent(formatData, "total_row"),
    };
    formatData.push(calPercent);

    setTbData({
      raw: formatData,
      format: null,
      export: null,
    });
  }, [apiData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
      })}
    </>
  );
}
